/**
 * The wordmark, inlined rather than fetched.
 *
 * It used to be a CSS `mask-image` pointing at /logos/balder-logo-black.svg, which meant a
 * network round-trip on a page that is by definition already having a bad time - the mark
 * popped in late and shifted nothing but looked broken. Inline it renders on the first
 * paint. `currentColor` keeps it working in both themes and on the fatal screen, which has
 * no theme at all.
 *
 * Sized by height; the aspect ratio comes from the viewBox.
 */
export const BalderWordmark = ({
  className,
  style,
}: {
  className?: string;
  style?: React.CSSProperties;
}) => (
  <svg
    viewBox="0 0 1260 133"
    fill="currentColor"
    role="img"
    aria-label="Balder"
    className={className}
    style={style}
  >
    <path d="M33 25.6H25V107.6H33H39.2V132H33H6H2.98023e-08V0.999994H6H33H39.2V25.6H33ZM212.52 62.6C222.32 69.8 228.12 81.4 228.12 93.6C228.12 114.8 210.92 132.2 189.52 132.2H103.32V0.199992H174.12C195.32 0.199992 212.72 17.6 212.72 38.8C212.72 43.6 211.72 48.6 209.92 53.2L207.52 58.8L212.52 62.6ZM125.52 22.6V55H174.12C183.12 55 190.32 47.8 190.32 38.8C190.32 29.8 183.12 22.6 174.12 22.6H125.52ZM189.52 109.8C198.52 109.8 205.92 102.6 205.92 93.6C205.92 84.6 198.52 77.4 189.52 77.4H125.52V109.8H189.52ZM371.748 0.199992L430.348 132.2H402.348L391.748 108H315.748L304.948 132.2H277.148L335.748 0.199992H371.748ZM353.748 22.6L324.548 88.2H382.948L353.748 22.6ZM595.731 109.4V132.2H494.531V0.199992H519.931V109.4H595.731ZM737.161 0.199992C766.961 0.199992 791.161 24.4 791.161 54V78.2C791.161 108 766.961 132.2 737.161 132.2H659.961V0.199992H737.161ZM765.561 78.2V54C765.561 38.4 752.761 25.8 737.161 25.8H685.361V106.6H737.161C752.761 106.6 765.561 93.8 765.561 78.2ZM880.478 19.8V56.2H956.278V76.2H880.478V112.4H964.878V132.2H855.078V0.199992H964.878V19.8H880.478ZM1137.91 90.4C1147.91 102.2 1154.11 116.8 1155.91 132H1130.31C1129.71 126.4 1128.11 121 1125.71 116C1118.51 100.4 1103.51 89.6 1087.51 88.6C1085.51 88.4 1081.71 88.4 1077.71 88.4C1075.71 88.4 1073.91 88.4 1072.71 88.4H1054.11V132H1028.91V0.599999H1030.31V0.199992H1111.51C1135.91 0.199992 1155.71 20 1155.71 44.2C1155.71 57.8 1149.51 70.4 1138.91 78.8L1132.51 84L1137.91 90.4ZM1111.51 66C1123.51 66 1133.31 56.2 1133.31 44.2C1133.31 32.4 1123.51 22.6 1111.51 22.6H1054.11V66H1111.51ZM1225.92 25.6H1219.92V0.999994H1225.92H1252.92H1259.12V132H1252.92H1225.92H1219.92V107.6H1225.92H1234.12V25.6H1225.92Z" />
  </svg>
);
